import { render, staticRenderFns } from "./ButtonListType.vue?vue&type=template&id=2375fafa&"
import script from "./ButtonListType.vue?vue&type=script&lang=ts&"
export * from "./ButtonListType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports